import { Break } from '../model/break.model'
import { ExternalDataSourceType } from '@helios/common-api'
import { CashBreakInfo } from '@helios/copilot'

/**
 * Create CashBreakInfo object from break model
 */
export function breakToCashBreakInfo(
  breakModel: Break,
  accountClient: [string, string],
): CashBreakInfo {
  return {
    breakId: breakModel.identifier,
    accountId: breakModel.acctId,
    securityId: breakModel.securityId,
    assetId: breakModel.securityIdentifier,
    source: breakModel.dataSourceTypes[0] as ExternalDataSourceType,
    difference: getPositionDifference(breakModel),
    clientName: accountClient[0],
    clientId: accountClient[1],
  }
}

/**
 *
 */
function getPositionDifference(breakModel: Break): number {
  if (breakModel.issueGroup == 'MISSING_EXTERNAL_POSITION') {
    return -parseFloat(<string>breakModel.metaData?.['CWAN Value'])
  }
  if (!breakModel.metaData?.['Difference']) {
    throw new Error('Missing position difference in metadata')
  }
  return parseFloat(<string>breakModel.metaData?.['Difference'])
}
